import useWizardFormCtx from '../../../ctx-provider/useWizardFormCtx';
import TextInputField from '../../../../../cmp/input/TextInputField';
import useInputSubmitValidator, { generateValidatorId } from '../../../../../../form/input/useInputSubmitValidator';
import VnAnschriftOrtValidator from './VnAnschriftOrtValidator';
import FormBo from '../../FormBo';
import StringUtil from '../../../../../../app/util/StringUtil';
import { useEffect, useState } from 'react';
import GtmFormularfeldId from '../../../../../../gtm/types/GtmFormularfeldId';

export const exportVnAnschriftOrt = (bo: FormBo) => StringUtil.trim(bo.vnAnschriftOrt);

export const importVnAnschriftOrt = (vnAnschriftOrt: string) => {
    const prepStr = StringUtil.substring(vnAnschriftOrt, VnAnschriftOrtValidator.MAX_LENGTH);
    return new VnAnschriftOrtValidator(vnAnschriftOrt).validate().error ? undefined : prepStr;
}

const VALIDATOR_ID = generateValidatorId("Antrag-VnAnschriftOrt");

const VnAnschriftOrt = () => {
    // *** Formulardaten werden geladen
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const [vnAnschriftOrt, setVnAnschriftOrt] = useState(wizardFormBo.antrag.vnAnschriftOrt);

    const { fireFieldValidation, validationState } = useInputSubmitValidator(VALIDATOR_ID, new VnAnschriftOrtValidator(vnAnschriftOrt));

    const updateValidationState = (value?: string) => {
        fireFieldValidation(new VnAnschriftOrtValidator(value));
    }

    // ****************************
    // init
    // ****************************
    useEffect(() => {
        if (!StringUtil.isBlank(vnAnschriftOrt)) {
            updateValidationState(vnAnschriftOrt);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // ****************************
    // events
    // ****************************   
    const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        updateValidationState(value);

        wizardFormBo.antrag.vnAnschriftOrt = value;
        fireWizardFormBo(wizardFormBo);
    }

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setVnAnschriftOrt(event.target.value);
    }

    return (
        <TextInputField id="vnAnschriftOrt" idGtm={GtmFormularfeldId.vnAnschriftOrt} label="Ort"
            value={vnAnschriftOrt}
            onBlur={handleOnBlur}
            onChange={handleOnChange}
            required={true}
            error={validationState.error}
            helperText={validationState.message}
            maxLength={VnAnschriftOrtValidator.MAX_LENGTH}
        />
    );
}

export default VnAnschriftOrt;